<template>
    <div class="bg-light">
        <div class="section py-5">
            <div class="section-bg" style="background-image: url(/beta/static/img/contact-bg/contact-paris.jpg);"></div>
            <div class="section-bg bg-gray-800 opacity-50"></div>
            <div class="container position-relative text-white text-center">
                <div class="display-6 fw-bolder">Let's Work Together</div>
            </div>
        </div>
        <div class="section">
            <div class="container">
                <div class="row row-space-30">
                    <div class="col-lg-12">
                        <h4>Have a question?</h4>
                        <p>Contact us </p>
                        <div :class="message.alert" class="alert text-center" v-if="message.text" role="alert">
                            {{ message.text }}
                        </div>
                        <div class="form-horizontal">
                            <div class="row gx-2">
                                <div class="col-lg-6 mb-2">
                                    <div class="input-group">
                                        <span class="input-group-text"><i class="fa fa-vcard-o"></i></span>
                                        <select required v-model="userContact.youare" :class="{ 'text-muted': !userContact.youare }" class="form-select form-select-lg" aria-label="You Are *">
                                            <option disabled value="">You Are *</option>
                                            <option value="Clinician">Clinician</option>
                                            <option value="Healthcare institution">Healthcare institution</option>
                                            <option value="University">University</option>
                                            <option value="Developer">Developer</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-lg-6 mb-2">
                                    <div class="input-group">
                                        <span class="input-group-text"><i class="fa fa-handshake-o"></i></span>
                                        <select required v-model="userContact.ineedto" :class="{ 'text-muted': !userContact.ineedto }" class="form-select form-select-lg" aria-label="You Need To *">
                                            <option disabled value="">You Need To *</option>
                                            <option value="Get more informations">Get more informations</option>
                                            <option value="Create your Data catalog">Create your Data catalog</option>
                                            <option value="Distribute your  Data catalog">Distribute your  Data catalog</option>
                                            <option value="Annotate your Data catalog">Annotate your Data catalog</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row gx-2">
                                <div class="col-lg-6 mb-2">
                                    <div class="input-group">
                                        <span class="input-group-text"><i class="fa fa-user-o"></i></span>
                                        <input type="text" v-model="userContact.fullname" class="form-control form-control-lg" placeholder="Full Name *" required />
                                    </div>
                                </div>
                                <div class="col-lg-6 mb-2">
                                    <div class="input-group">
                                        <span class="input-group-text"><i class="fa fa-at"></i></span>
                                        <input type="email" v-model="userContact.email" class="form-control form-control-lg" placeholder="Professionnal Email *" required />
                                    </div>
                                </div>
                            </div>
                            <div class="row gx-2">
                                <div class="col-lg-6 mb-2">
                                    <div class="input-group">
                                        <span class="input-group-text"><i class="fa fa-building-o"></i></span>
                                        <input type="text" v-model="userContact.institution" class="form-control form-control-lg" placeholder="Institution Name *" required />
                                    </div>
                                </div>
                                <div class="col-lg-6 mb-2">
                                    <div class="input-group">
                                        <span class="input-group-text"><i class="fa fa-globe"></i></span>
                                        <select required v-model="userContact.country" :class="{ 'text-muted': !userContact.country }" class="form-select form-select-lg" aria-label="Country *">
                                            <option disabled value="">Country *</option>
                                            <option v-for="country in countries" :key="country.value" :value="country.value">
                                                {{ country.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="mb-2 pb-2px">
                                <div class="input-group">
                                    <span class="input-group-text" style="align-items: flex-start;"><i class="fa fa-envelope-o"></i></span>
                                    <textarea v-model="userContact.message" class="form-control form-control-lg" rows="6" placeholder="Message *" required></textarea>
                                </div>
                            </div>
                            <button class="btn btn-primary get-started rounded-pill" @click.prevent="sendContactUsMsg">Send Message</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ContactUs",
    created() {
        this.fetchCountries();
    },
    data() {
        return {
            userContact: {
                youare: "",
                ineedto: "",
                fullname: "",
                email: "",
                institution: "",
                country: "",
                message: "",
            },
            message: {},
            countries: [],
        };
    },
    methods: {
        showMessage(message) {
            this.message = message;
        },
        sendContactUsMsg() {
            if (Object.keys(this.userContact).some((key) => !this.userContact[key])) {
                this.showMessage({ text: "Please fill in all required fields", alert: "alert-danger" });
                return;
            }
            this.$http
                .post("contact/contact-us", this.userContact)
                .then((response) => {
                    this.showMessage({ text: "Your message has been successfully sent", alert: "alert-success" });
                    this.userContact = { youare: "", ineedto: "", fullname: "", email: "", institution: "", country: "", message: "" }; // Reset form
                })
                .catch((err) => {
                    console.error(err);
                    this.showMessage({ text: "Sorry, your message was not sent. Please try again later.", alert: "alert-danger" });
                });
        },
        fetchCountries() {
            fetch("https://restcountries.com/v3.1/all")
                .then((response) => response.json())
                .then((data) => {
                    this.countries = data.map((country) => {
                        return { name: country.name.common, value: country.cca2 }; // cca2 is the country code
                    }).sort((a, b) => a.name.localeCompare(b.name));
                })
                .catch((error) => console.error("Error fetching countries:", error));
        },
    },
};
</script>
<style scoped>
.input-group .input-group-text {
    background: #fff;
    border-right: none;
    z-index: 100;
    width: 34px;
}
.input-group .form-control,
.input-group .form-select {
    border-left: none;
}
.input-group i.fa {
    font-size: 20px;
    color: #8d8d8d;
}
.get-started {
  background: #E95913 !important;
}
.get-started:hover {
  background:  #E95913af !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/public/Contact.vue